import { useMutation, useQueryClient } from "@tanstack/react-query"
import { createProgram } from "../../services/program";
import { IIndicators } from "../../types";
import { toast } from "react-toastify";

const useCreateProgram = (indicators: IIndicators) => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: createProgram,

        onMutate: () => {
            indicators.setIsProcessRunning(true);
        },

        onSuccess: (status) => {
            if (status === 200) {
                indicators.setIsProcessRunning(false);
                queryClient.invalidateQueries({ queryKey: ['categories'] });
                toast.success("Program created successfully");
            }
        },

        onError: (error: any) => {
            indicators.setIsProcessRunning(false);
            indicators.setIsServiceError(error.response?.data?.message);
            toast.error(error.response?.data?.message);
        }
    });
};

export default useCreateProgram;